/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-01-15 16:09:17
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-02-27 18:30:34
 * @FilePath: /miaobi-admin-magic-touch/src/plugins/modal.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElLoading,
} from "element-plus";
import { translate } from '@/locales/route'

let loadingInstance;

export default {
  // 消息提示
  msg(content) {
    ElMessage.info(content);
  },
  // 错误消息
  msgError(content) {
    ElMessage.error(content);
  },
  // 成功消息
  msgSuccess(content) {
    ElMessage.success(content);
  },
  // 警告消息
  msgWarning(content) {
    ElMessage.warning(content);
  },
  // 弹出提示
  alert(content) {
    ElMessageBox.alert(content, translate('modal.systemPrompt'));
  },
  // 错误提示
  alertError(content) {
    ElMessageBox.alert(content, translate('modal.systemPrompt'), { type: "error" });
  },
  // 成功提示
  alertSuccess(content) {
    ElMessageBox.alert(content, translate('modal.systemPrompt'), { type: "success" });
  },
  // 警告提示
  alertWarning(content) {
    ElMessageBox.alert(content, translate('modal.systemPrompt'), { type: "warning" });
  },
  // 通知提示
  notify(content) {
    ElNotification.info(content);
  },
  // 错误通知
  notifyError(content) {
    ElNotification.error(content);
  },
  // 成功通知
  notifySuccess(content) {
    ElNotification.success(content);
  },
  // 警告通知
  notifyWarning(content) {
    ElNotification.warning(content);
  },
  // 确认窗体
  confirm(content) {
    return ElMessageBox.confirm(content, translate('modal.systemPrompt'), {
      confirmButtonText: translate('common.confirm'),
      cancelButtonText: translate('common.cancel'),
      type: "warning",
    });
  },
  // 提交内容
  prompt(content) {
    return ElMessageBox.prompt(content, translate('modal.systemPrompt'), {
      confirmButtonText: translate('common.confirm'),
      cancelButtonText: translate('common.cancel'),
      type: "warning",
    });
  },
  // 打开遮罩层
  loading(content) {
    loadingInstance = ElLoading.service({
      lock: true,
      text: content,
      background: "rgba(0, 0, 0, 0.7)",
    });
  },
  // 关闭遮罩层
  closeLoading() {
    loadingInstance.close();
  },
};
